import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Mail, Phone, MapPin, Instagram, Facebook, Youtube } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | 'contact' | null>(null);
  const closeModal = () => setActiveModal(null);
  const socialLinks = [{
    name: 'Instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/kiosscodigital/',
    gradient: 'from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]'
  }, {
    name: 'Facebook',
    icon: Facebook,
    url: 'https://www.facebook.com/contactokd',
    gradient: 'from-[#1877f2] to-[#0d5dbf]'
  }, {
    name: 'YouTube',
    icon: Youtube,
    url: 'https://www.youtube.com/@mikioscodigital',
    gradient: 'from-[#ff0000] to-[#cc0000]'
  }];
  return <>
      <footer className="relative bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-black text-white overflow-hidden" data-id="element-149">
        {/* Luxury background effects */}
        <div className="absolute inset-0 opacity-30" data-id="element-150">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-[#FFD700]/20 to-transparent rounded-full blur-3xl animate-pulse" data-id="element-151" />
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-br from-[#FFA500]/20 to-transparent rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-152" />
        </div>

        {/* Animated golden lines */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#FFD700] to-transparent opacity-50" data-id="element-153" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10" data-id="element-154">
          {/* Main content grid */}
          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-155">
            {/* Brand section */}
            <div className="space-y-4" data-id="element-156">
              <div className="relative inline-block" data-id="element-157">
                <h3 className="text-2xl font-serif font-bold bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FFD700] bg-clip-text text-transparent mb-2" data-id="element-158">
                  Plan Anti-Pantallas
                </h3>
                <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#FFD700] to-transparent" data-id="element-159" />
              </div>
              <p className="text-gray-400 leading-relaxed" data-id="element-160">
                Ayudando a familias a reconectar y encontrar calma en el caos
                digital.
              </p>

              {/* Premium badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#FFD700]/10 to-[#FFA500]/10 border border-[#FFD700]/30 rounded-full" data-id="element-161">
                <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse" data-id="element-162" />
                <span className="text-[#FFD700] text-sm font-semibold" data-id="element-163">
                  Edición Premium
                </span>
              </div>
            </div>

            {/* Links section */}
            <div className="space-y-4" data-id="element-164">
              <div className="flex flex-col gap-3" data-id="element-165">
                <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-[#FFD700] transition-colors text-left group flex items-center gap-2" data-id="element-166">
                  <span className="w-1.5 h-1.5 bg-[#FFD700] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-167" />
                  Términos y Condiciones
                </button>
                <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-[#FFD700] transition-colors text-left group flex items-center gap-2" data-id="element-168">
                  <span className="w-1.5 h-1.5 bg-[#FFD700] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-169" />
                  Política de Privacidad
                </button>
                <button onClick={() => setActiveModal('contact')} className="text-gray-400 hover:text-[#FFD700] transition-colors text-left group flex items-center gap-2" data-id="element-170">
                  <span className="w-1.5 h-1.5 bg-[#FFD700] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-171" />
                  Contacto
                </button>
              </div>
            </div>

            {/* Social media section */}
            <div className="space-y-4" data-id="element-172">
              <h4 className="text-lg font-bold text-[#FFD700] mb-4" data-id="element-173">
                Síguenos
              </h4>

              {/* 3D Luxury Social Icons */}
              <div className="flex gap-4" data-id="element-174">
                {socialLinks.map((social, i) => <a key={i} href={social.url} target="_blank" rel="noopener noreferrer" className="group relative" aria-label={social.name} data-id="element-175">
                    {/* Glow effect */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#FFD700]/30 to-[#FFA500]/30 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-176" />

                    {/* 3D Container */}
                    <div className="relative w-14 h-14 transform-gpu transition-all duration-300 group-hover:scale-110 group-hover:-translate-y-1" data-id="element-177">
                      {/* Back layer (shadow) */}
                      <div className="absolute inset-0 bg-gradient-to-br from-black to-gray-900 rounded-2xl transform translate-y-1 translate-x-1" data-id="element-178" />

                      {/* Middle layer (depth) */}
                      <div className="absolute inset-0 bg-gradient-to-br from-[#2a2a2a] to-black rounded-2xl transform translate-y-0.5 translate-x-0.5" data-id="element-179" />

                      {/* Front layer (main) */}
                      <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a1a] via-black to-[#0a0a0a] rounded-2xl border border-[#FFD700]/20 group-hover:border-[#FFD700]/50 transition-colors overflow-hidden" data-id="element-180">
                        {/* Shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-br from-[#FFD700]/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-181" />

                        {/* Animated shimmer */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#FFD700]/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-182" />

                        {/* Icon */}
                        <div className="absolute inset-0 flex items-center justify-center" data-id="element-183">
                          <social.icon className="w-6 h-6 text-[#FFD700] group-hover:text-white transition-colors relative z-10 drop-shadow-[0_0_8px_rgba(255,215,0,0.5)]" data-id="element-184" />
                        </div>

                        {/* Inner glow */}
                        <div className="absolute inset-0 rounded-2xl shadow-inner shadow-[#FFD700]/10" data-id="element-185" />
                      </div>

                      {/* Floating particles effect */}
                      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-186">
                        <div className="absolute top-0 left-1/2 w-1 h-1 bg-[#FFD700] rounded-full animate-ping" style={{
                      animationDuration: '2s'
                    }} data-id="element-187" />
                        <div className="absolute bottom-0 right-1/4 w-1 h-1 bg-[#FFA500] rounded-full animate-ping" style={{
                      animationDuration: '2.5s',
                      animationDelay: '0.5s'
                    }} data-id="element-188" />
                      </div>
                    </div>
                  </a>)}
              </div>
            </div>
          </div>

          {/* Divider with golden accent */}
          <div className="relative mb-8" data-id="element-189">
            <div className="absolute inset-0 flex items-center" data-id="element-190">
              <div className="w-full border-t border-gray-800" data-id="element-191" />
            </div>
            <div className="relative flex justify-center" data-id="element-192">
              <div className="px-4 bg-gradient-to-r from-transparent via-[#FFD700]/20 to-transparent" data-id="element-193">
                <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse" data-id="element-194" />
              </div>
            </div>
          </div>

          {/* Bottom section */}
          <div className="space-y-6" data-id="element-195">
            {/* Disclaimer */}
            <div className="bg-gradient-to-r from-[#FFD700]/5 to-transparent border-l-2 border-[#FFD700]/30 p-4 rounded-r-lg" data-id="element-196">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-197">
                <span className="text-gray-500 font-semibold" data-id="element-198">disclaimer:</span>{' '}
                Este producto es una guía educativa y de entretenimiento. Los
                resultados pueden variar según la implementación y el contexto
                familiar. No sustituye el consejo médico o psicológico
                profesional.
              </p>
            </div>

            {/* Copyright */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-600" data-id="element-199">
              <p data-id="element-200">
                &copy; {new Date().getFullYear()} Plan Anti-Pantallas. Todos los
                derechos reservados.
              </p>
              <div className="flex items-center gap-2" data-id="element-201">
                <span data-id="element-202">Hecho con</span>
                <span className="text-[#FFD700] animate-pulse" data-id="element-203">♥</span>
                <span data-id="element-204">para familias</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom golden line */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#FFD700] to-transparent opacity-50" data-id="element-205" />
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contacto" data-id="element-206">
        <div className="space-y-6" data-id="element-207">
          <p className="text-slate-700 leading-relaxed" data-id="element-208">
            ¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para
            ayudarte. Puedes contactarnos a través de los siguientes medios:
          </p>

          <div className="space-y-4" data-id="element-209">
            <div className="flex items-start gap-4 p-4 bg-brand-cream/30 rounded-xl" data-id="element-210">
              <div className="flex-shrink-0 w-10 h-10 bg-brand-navy rounded-full flex items-center justify-center" data-id="element-211">
                <Mail className="w-5 h-5 text-white" data-id="element-212" />
              </div>
              <div data-id="element-213">
                <h4 className="font-bold text-brand-navy mb-1" data-id="element-214">Email</h4>
                <p className="text-slate-700 text-sm mb-2" data-id="element-215">
                  Para consultas generales, soporte o devoluciones:
                </p>
                <a href="mailto:contactomikioscodigital@gmail.com" className="text-brand-red font-medium hover:underline" data-id="element-216">
                  contactomikioscodigital@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-brand-cream/30 rounded-xl" data-id="element-217">
              <div className="flex-shrink-0 w-10 h-10 bg-brand-navy rounded-full flex items-center justify-center" data-id="element-218">
                <Phone className="w-5 h-5 text-white" data-id="element-219" />
              </div>
              <div data-id="element-220">
                <h4 className="font-bold text-brand-navy mb-1" data-id="element-221">WhatsApp</h4>
                <p className="text-slate-700 text-sm mb-2" data-id="element-222">
                  Atención al cliente de lunes a viernes, 9:00 - 18:00
                </p>
                <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="text-brand-red font-medium hover:underline" data-id="element-223">
                  +1 (234) 567-890
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-brand-cream/30 rounded-xl" data-id="element-224">
              <div className="flex-shrink-0 w-10 h-10 bg-brand-navy rounded-full flex items-center justify-center" data-id="element-225">
                <MapPin className="w-5 h-5 text-white" data-id="element-226" />
              </div>
              <div data-id="element-227">
                <h4 className="font-bold text-brand-navy mb-1" data-id="element-228">Ubicación</h4>
                <p className="text-slate-700 text-sm" data-id="element-229">
                  Plan Anti-Pantallas
                  <br data-id="element-230" />
                  Ciudad, País
                </p>
              </div>
            </div>
          </div>

          <div className="bg-brand-yellow/10 border-l-4 border-brand-yellow p-4 rounded-r-xl" data-id="element-231">
            <h4 className="font-bold text-brand-navy mb-2" data-id="element-232">
              Tiempo de Respuesta
            </h4>
            <p className="text-slate-700 text-sm" data-id="element-233">
              Nos esforzamos por responder todas las consultas en un plazo de
              24-48 horas hábiles. Para solicitudes de reembolso, el proceso
              puede tomar de 3 a 5 días hábiles.
            </p>
          </div>

          <div className="bg-brand-green/10 border-l-4 border-brand-green p-4 rounded-r-xl" data-id="element-234">
            <h4 className="font-bold text-brand-navy mb-2" data-id="element-235">Soporte Técnico</h4>
            <p className="text-slate-700 text-sm" data-id="element-236">
              Si tienes problemas para descargar o acceder a tu producto,
              incluye en tu mensaje:
            </p>
            <ul className="list-disc list-inside text-slate-700 text-sm mt-2 space-y-1" data-id="element-237">
              <li data-id="element-238">Tu correo electrónico de compra</li>
              <li data-id="element-239">Número de orden (si lo tienes)</li>
              <li data-id="element-240">Descripción del problema</li>
            </ul>
          </div>
        </div>
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-241">
        <div className="prose prose-sm max-w-none" data-id="element-242">
          <p className="text-slate-600 mb-4" data-id="element-243">
            <strong data-id="element-244">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-245">
            1. Aceptación de los Términos
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-246">
            Al adquirir y utilizar el Plan Anti-Pantallas Express, aceptas estos
            términos y condiciones en su totalidad. Si no estás de acuerdo con
            alguna parte de estos términos, no debes utilizar nuestro producto.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-247">
            2. Descripción del Producto
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-248">
            El Plan Anti-Pantallas Express es un producto digital (ebook en
            formato PDF) que incluye:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-249">
            <li data-id="element-250">Ebook principal con 30 actividades sin pantallas</li>
            <li data-id="element-251">6 ebooks complementarios especializados</li>
            <li data-id="element-252">Guías de implementación paso a paso</li>
            <li data-id="element-253">Material imprimible para uso personal</li>
          </ul>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-254">
            3. Licencia de Uso
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-255">
            Se te otorga una licencia personal, no transferible y no exclusiva
            para:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-256">
            <li data-id="element-257">
              Descargar y utilizar el contenido para uso personal y familiar
            </li>
            <li data-id="element-258">Imprimir las actividades para uso en tu hogar</li>
            <li data-id="element-259">Acceder al material de forma ilimitada</li>
          </ul>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-260">
            <strong data-id="element-261">No está permitido:</strong> Revender, redistribuir,
            compartir públicamente, modificar para uso comercial, o reclamar
            autoría del contenido.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-262">
            4. Garantía de Satisfacción
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-263">
            Ofrecemos una garantía de devolución de 30 días. Si no estás
            satisfecho con el producto, puedes solicitar un reembolso completo
            dentro de los primeros 30 días posteriores a la compra, sin
            preguntas.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-264">
            5. Limitación de Responsabilidad
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-265">
            Este producto es una guía educativa y de entretenimiento. Los
            resultados pueden variar según la implementación, el contexto
            familiar y las características individuales de cada niño. No
            sustituye el consejo médico, psicológico o educativo profesional.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-266">
            6. Propiedad Intelectual
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-267">
            Todo el contenido, incluyendo textos, imágenes, diseños y
            actividades, está protegido por derechos de autor y es propiedad
            exclusiva de Plan Anti-Pantallas.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-268">
            7. Modificaciones
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-269">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-270">
            8. Contacto
          </h3>
          <p className="text-slate-700 leading-relaxed" data-id="element-271">
            Para cualquier consulta sobre estos términos, puedes contactarnos a
            través de la sección de Contacto.
          </p>
        </div>
      </Modal>

      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-272">
        <div className="prose prose-sm max-w-none" data-id="element-273">
          <p className="text-slate-600 mb-4" data-id="element-274">
            <strong data-id="element-275">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-276">
            1. Información que Recopilamos
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-277">
            Al realizar una compra, recopilamos la siguiente información:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-278">
            <li data-id="element-279">
              <strong data-id="element-280">Información de contacto:</strong> nombre, dirección de
              correo electrónico
            </li>
            <li data-id="element-281">
              <strong data-id="element-282">Información de pago:</strong> procesada de forma segura
              por nuestro procesador de pagos (no almacenamos datos de tarjetas)
            </li>
            <li data-id="element-283">
              <strong data-id="element-284">Información de uso:</strong> datos de navegación y uso del
              sitio web (cookies, dirección IP, tipo de navegador)
            </li>
          </ul>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-285">
            2. Cómo Utilizamos tu Información
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-286">
            Utilizamos tu información para:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-287">
            <li data-id="element-288">Procesar tu compra y entregarte el producto digital</li>
            <li data-id="element-289">Enviarte confirmaciones de compra y acceso al material</li>
            <li data-id="element-290">Proporcionar soporte al cliente</li>
            <li data-id="element-291">
              Enviar actualizaciones del producto (solo si has dado tu
              consentimiento)
            </li>
            <li data-id="element-292">Mejorar nuestros productos y servicios</li>
            <li data-id="element-293">Cumplir con obligaciones legales</li>
          </ul>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-294">
            3. Compartir Información
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-295">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, excepto:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-296">
            <li data-id="element-297">
              Procesadores de pago necesarios para completar tu transacción
            </li>
            <li data-id="element-298">
              Proveedores de servicios que nos ayudan a operar nuestro negocio
              (bajo acuerdos de confidencialidad)
            </li>
            <li data-id="element-299">
              Cuando sea requerido por ley o para proteger nuestros derechos
              legales
            </li>
          </ul>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-300">
            4. Cookies y Tecnologías de Seguimiento
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-301">
            Utilizamos cookies y tecnologías similares para:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-302">
            <li data-id="element-303">Recordar tus preferencias</li>
            <li data-id="element-304">Analizar el tráfico del sitio web</li>
            <li data-id="element-305">Mejorar la experiencia del usuario</li>
            <li data-id="element-306">Realizar marketing y publicidad (con tu consentimiento)</li>
          </ul>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-307">
            Puedes controlar las cookies a través de la configuración de tu
            navegador.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-308">
            5. Seguridad de los Datos
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-309">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración. Sin embargo, ningún método de transmisión por
            internet es 100% seguro.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-310">
            6. Tus Derechos
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-311">
            Tienes derecho a:
          </p>
          <ul className="list-disc list-inside text-slate-700 mb-4 space-y-1" data-id="element-312">
            <li data-id="element-313">Acceder a tu información personal</li>
            <li data-id="element-314">Rectificar datos inexactos</li>
            <li data-id="element-315">Solicitar la eliminación de tus datos</li>
            <li data-id="element-316">Oponerte al procesamiento de tus datos</li>
            <li data-id="element-317">Retirar tu consentimiento en cualquier momento</li>
            <li data-id="element-318">Solicitar la portabilidad de tus datos</li>
          </ul>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-319">
            7. Retención de Datos
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-320">
            Conservamos tu información personal durante el tiempo necesario para
            cumplir con los propósitos descritos en esta política, a menos que
            la ley requiera o permita un período de retención más largo.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-321">
            8. Enlaces a Terceros
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-322">
            Nuestro sitio puede contener enlaces a sitios web de terceros. No
            somos responsables de las prácticas de privacidad de estos sitios.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-323">
            9. Cambios a esta Política
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-324">
            Podemos actualizar esta política de privacidad periódicamente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en nuestro sitio web.
          </p>

          <h3 className="text-lg font-bold text-brand-navy mt-6 mb-3" data-id="element-325">
            10. Contacto
          </h3>
          <p className="text-slate-700 leading-relaxed" data-id="element-326">
            Si tienes preguntas sobre esta política de privacidad o deseas
            ejercer tus derechos, contáctanos a través de la sección de
            Contacto.
          </p>
        </div>
      </Modal>
    </>;
}